/**
 * The default server URL to open if no other was specified.
 */
export const DEFAULT_SERVER_URL = 'https://comrex-dev.panthermediasystem.net';
// export const DEFAULT_SERVER_URL = 'https://gagl.comrex.com';
// dev plans
const GAGL_DEV_PLANS = {
    MONTHLY: 'Gagl.mnthly',
    YEARLY: 'Gagl.yrly',
    HOTLINE_MONTHLY: 'gagl.hotline.monthly',
    HOTLINE_YEARLY: 'gagl.hotline.yearly',
    SOLO: 'gagl.solo',
};
// prod plans
const GAGL_PROD_PLANS = {
    MONTHLY: 'gagl.monthly',
    YEARLY: 'gagl.yearly',
    HOTLINE_MONTHLY: 'gagl.hotline.monthly',
    HOTLINE_YEARLY: 'gagl.hotline.yearly',
    SOLO: 'gagl.solo',
};
export const GAGL_PLANS = process.env.NODE_ENV !== 'production' ? GAGL_DEV_PLANS : GAGL_PROD_PLANS;
